import { useRouter } from "vue-router"
import { useOrderDetail } from "../../OrderShipmentData/store/OrderShipmentData.store"
import { useOrderStore } from "../../TableArticules/store/Order.store"




// Composable
export const useCancelOrder = () => {
    
    const orderArticles = useOrderStore()
    const orderDetails = useOrderDetail()
    const router = useRouter()

    /**
     * Funcion para cancelar el flujo de la orden y redireccionar a la ruta main de la aplicacion.
     * Limpia los siguientes stores: useOrderStore(), useOrderDetail()
     * @returns void
    */
    const cancelOrder = (): void => {
        orderArticles.clearArticlesOrder()
        orderDetails.resetOrderDetails()
        orderDetails.resetAkeronService()
        router.push('/table-content')
    }

    return { 

        // Actions
        cancelOrder 
    }
}

